var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcBrandAppleSolid = function SvgIcBrandAppleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.897 5.046A4.16 4.16 0 0 0 15.903 2a4.53 4.53 0 0 0-2.897 1.448 4 4 0 0 0-1.033 2.933c1.12.011 2.222-.492 2.924-1.335M17.364 12.104c.02-1.467.834-2.854 2.128-3.623-.816-1.125-2.183-1.84-3.605-1.882-1.516-.154-2.986.876-3.76.876-.787 0-1.977-.861-3.258-.836-1.67.053-3.227.97-4.04 2.38-1.746 2.922-.443 7.216 1.23 9.577.837 1.157 1.815 2.449 3.095 2.403 1.253-.05 1.72-.772 3.233-.772 1.498 0 1.937.772 3.243.743 1.344-.021 2.191-1.162 2.999-2.33A9.4 9.4 0 0 0 20 15.944c-1.58-.646-2.635-2.182-2.636-3.839"
  })));
};
export default SvgIcBrandAppleSolid;